// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Motion$LiteracyplanetTupperware from "./Motion.res.mjs";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";
import * as PlayAudioIcon$LiteracyplanetTupperware from "../v2/PlayAudioIcon.res.mjs";
import * as StimulusToggleContext$LiteracyplanetTupperware from "../v2/StimulusToggleContext.res.mjs";
import * as V3AudioEmbeddedComponent$LiteracyplanetTupperware from "./V3AudioEmbeddedComponent.res.mjs";

function V3StimulusWithImageAndAudio(props) {
  var sources = props.sources;
  var match = Curry._1(StimulusToggleContext$LiteracyplanetTupperware.useState, undefined);
  var onToggleStimulus = match[1];
  return React.createElement("div", {
              className: "h-screen w-screen absolute left-0 top-0 z-50 flex justify-center items-center",
              onClick: (function (param) {
                  Curry._1(onToggleStimulus, undefined);
                })
            }, React.createElement("div", {
                  className: "relative w-[90%] max-w-[1024px] h-[80vh] overflow-x-scroll bg-white rounded-md border border-slate-200 shadow-md"
                }, React.createElement("div", {
                      className: "pilot-tutorial-text-header"
                    }, sources !== undefined ? React.createElement(V3AudioEmbeddedComponent$LiteracyplanetTupperware.V3AudioEmbeddedComponent.make, {
                            audioId: "stimulusWithImageAndAudio",
                            sources: sources,
                            autoPlay: false,
                            children: (function (state) {
                                var tmp;
                                switch (state) {
                                  case "Loading" :
                                      tmp = "";
                                      break;
                                  case "Stopped" :
                                      tmp = "Play";
                                      break;
                                  case "Playing" :
                                      tmp = "Stop";
                                      break;
                                  
                                }
                                return React.createElement("div", {
                                            className: "flex text-lg justify-end items-center text-white gap-5"
                                          }, React.createElement(PlayAudioIcon$LiteracyplanetTupperware.make, {
                                                className: "w-8 h-8",
                                                state: state
                                              }), tmp);
                              })
                          }) : null), React.createElement("div", {
                      className: "image-place"
                    }, React.createElement(V3RefManager$LiteracyplanetTupperware.MakeRefContainer.make, {
                          id: "stimulusImage",
                          children: null
                        })), React.createElement(V3RefManager$LiteracyplanetTupperware.PortalImmediate.make, {
                      id: "showTutorialText",
                      children: React.createElement(Motion$LiteracyplanetTupperware.Div.make, {
                            initial: {
                              transform: "translateY(-100%)"
                            },
                            animate: {
                              transform: "translateY(0px)"
                            },
                            transition: {
                              type: "spring",
                              duration: 1
                            },
                            className: match[0] ? "invisible" : "",
                            children: Caml_option.some(React.createElement("button", {
                                      className: "pilot-lesson-button",
                                      onClick: (function (evt) {
                                          Curry._1(onToggleStimulus, undefined);
                                          evt.stopPropagation();
                                        })
                                    }, "Text"))
                          })
                    })), props.children);
}

var make = V3StimulusWithImageAndAudio;

export {
  make ,
}
/* react Not a pure module */
